import { supabase } from '@/lib/supabaseClient';
import { taskService } from '@/services/taskService';
import { buildMoveRequestCopy, type PlaceNames } from '@/lib/stageMovePicker';

/**
 * PMV-1.6. A move request is a task for the project's PM. Shared by the board's
 * right-click Request move and the project modal's Stage tile, so both send the
 * same task.
 */

export const NO_PM_MESSAGE = 'This project has no assigned Project Manager to receive the request';

export async function getProjectManagerName(pmId: string): Promise<string> {
  const { data } = await supabase.from('users').select('first_name, last_name').eq('id', pmId).single();
  return data ? `${data.first_name} ${data.last_name} (Project Manager)` : 'Project Manager';
}

export async function sendStageMoveRequest({
  pmId,
  projectId,
  projectName,
  from,
  to,
}: {
  pmId: string;
  projectId: string;
  projectName: string;
  from: PlaceNames;
  to: PlaceNames;
}): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('You must be logged in to make stage change requests');

  const { data: userData } = await supabase
    .from('users')
    .select('first_name, last_name')
    .eq('id', user.id)
    .single();

  const { title, description } = buildMoveRequestCopy({
    requesterName: userData ? `${userData.first_name} ${userData.last_name}` : 'A user',
    projectName,
    from,
    to,
  });

  await taskService.createTask({
    title,
    description,
    assignee_id: pmId,
    project_id: projectId,
    priority: 'medium',
  });
}
